import type { IConsentGroup } from '../types/IConsentConfig';

export const socialMediaConsentGroup: IConsentGroup = {
  key: 'social-media',
  title: 'Social Media',
  items: [
    {
      title: 'Instagram',
      description: 'Einbettung unseres Instagram-Feeds',
      key: 'allowInstagram',
    },
  ],
};
